import React from "react";
import RichText from "./RichText";
import LegalStrip from "./LegalStrip";

const Methodology = ({ methodology, agent }) => {
  if (!methodology) return null;
  const sample = methodology.sampleComposition;
  return (
    <section id="methodology" className="abr-section" aria-labelledby="abr-methodology-title">
      <div className="abr-eyebrow">Methodology</div>
      <h2 className="abr-h1" id="abr-methodology-title">
        {methodology.title}
      </h2>
      <p className="abr-lede">{methodology.lede}</p>

      <div className="abr-method-grid">
        {(methodology.blocks || []).map((block, idx) => (
          <div className="abr-method-block" key={idx}>
            <div className="abr-method-heading">{block.heading}</div>
            <RichText as="p" text={block.body} />
          </div>
        ))}

        {sample ? (
          <div className="abr-sample-comp">
            <div className="abr-method-heading">{sample.heading}</div>
            {(sample.paragraphs || []).map((p, idx) => (
              <RichText as="p" text={p} key={idx} />
            ))}
          </div>
        ) : null}
      </div>

      {methodology.disclaimer ? (
        <div className="abr-disclaimer">
          <div className="abr-disclaimer-heading">Disclaimer</div>
          <p>{methodology.disclaimer}</p>
          <p className="abr-disclaimer-attribution">
            <strong>Prepared by {agent.fullName}</strong>, {agent.title} at <strong>{agent.brokerage}</strong>.{" "}
            {agent.licenseLabel}. Member of {agent.mlsLabel.replace(/\s*Member\s*$/i, "")}. {agent.phoneDisplay}{" "}
            &middot;{" "}
            <a href={`mailto:${agent.email}`}>{agent.email}</a>. The Buyer Listing Service<sup>&reg;</sup> is a
            registered trademark.
          </p>
        </div>
      ) : null}

      <LegalStrip agent={agent} />
    </section>
  );
};

export default Methodology;
